import HttpClient from '@/services/http-client'

class MeterStatesAPI extends HttpClient {
  async show(id) {
    return this.rest.get('/v1/meter-states/' + id)
  }

  async list(page = 1, limit = 1000, text = null) {
    return this.rest.get('/v1/meter-states', {
      params: {
        page,
        limit,
        q: text
      }
    })
  }

  async create(payload) {
    return this.rest.post('/v1/meter-states', payload)
  }

  async update(payload) {
    return this.rest.patch('/v1/meter-states/' + payload.id, payload)
  }

  async delete(id) {
    return this.rest.delete('/v1/meter-states/' + id)
  }
}

export default () => new MeterStatesAPI()
